import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { ApiStatus } from "common/enums";
import { UserDetails } from "common/models";
import initialUserState from "./user.state";
import { CombineUsedProfile } from "common/models/user-details.model";
import { UserLoginStatus } from "common/enums/api-status.enum";

const userSlice = createSlice({
  name: "user",
  initialState: initialUserState,
  reducers: {
    getUserProfile: (state) => {
      state.profileApiStatus = ApiStatus.LOADING;
      state.avatarApiStatus = ApiStatus.LOADING;
      state.accessStatus = ApiStatus.LOADING;
    },
    getUserProfileSuccess: (
      state,
      { payload }: PayloadAction<CombineUsedProfile>
    ) => {
      const {
        displayName,
        id,
        givenName,
        surname,
        mail,
        userPrincipalName,
        userRole
      } = payload;
      state.id = id;
      state.displayName = displayName;
      state.givenName = givenName;
      state.surname = surname;
      state.mail = mail;
      state.userPrincipalName = userPrincipalName;
      state.profileApiStatus = ApiStatus.SUCCESS;
      state.userRole = userRole;
      state.accessStatus =
        userRole.length > 0 ? ApiStatus.SUCCESS : ApiStatus.ERROR;
    },
    getUserProfileError: (state) => {
      state.profileApiStatus = ApiStatus.ERROR;
      state.accessStatus = ApiStatus.ERROR;
    },
    getUserAvatarSuccess: (state, { payload }: PayloadAction<string>) => {
      state.avatar = payload;
      state.avatarApiStatus = ApiStatus.SUCCESS;
    },
    getUserAvatarError: (state) => {
      state.avatar = "";
      state.avatarApiStatus = ApiStatus.SUCCESS;
    },

    setUserSigningStatus: (
      state,
      { payload }: PayloadAction<UserLoginStatus>
    ) => {
      state.loginStatus = payload;
    },

    logoutUserBegin: (state) => {
      state.isTokenBlacklisted = false;
    },
    logoutUserSuccess: (state) => {
      state.isTokenBlacklisted = true;
    }
  }
});

export default userSlice.reducer;
export const userActions = userSlice.actions;
